module.exports = __webpack_public_path__ + "img/receipt_ai_guide.bdf30e27.png";